import {useCallback} from 'react'

import {rowIsExpanded} from '../../../hooks/tanstack-table/row-api'
import type {Row} from '../../../hooks/tanstack-table/types'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {useTableInstance} from '../table-provider'

/** Get all visible rows in the table, filtering out rows that are hidden in collapsed groups. */
export const useGetVisibleRows = () => {
  const tableInstance = useTableInstance()
  return useCallback(() => {
    const visibleRows = tableInstance.groupedRows?.reduce((acc: Array<Row<MemexItemModel>>, group) => {
      if (rowIsExpanded(group)) {
        acc.push(...group.subRows)
      }
      return acc
    }, [])
    return visibleRows ?? tableInstance.flatRows
  }, [tableInstance])
}
